export default class InputData {

    constructor() {

        this.currentPage = 0;
        this.loadFromPresta = false;

        this.agent = "";

        //screen 1
        this.Period = 0;
       
        this.EstablishmentUnit="";
        this.HomeRegionCode="";
        this.HiringType = 0;
        //this.Conjoint = "";
        this.Spouse=0;
        //this.PersonnesAcharge = false;
        this.Dependant=false;

        //this.EtatCivil = "";
        this.MaritalStatus=0;

        //this.DateNaissance = "";
        this.BirthDate="";

        //this.Handicape
        this.Disabled = false;

        //this.ConjointHandicape = false;
        this.DisabledSpouse=false;

        //this.NbEnfantsAcharge = 0;
        this.DependantChildren=0;
        
        //this.NbEnfantsHandicapesAcharge = 0;;
        this.DisabledDependantChildren=0;

        //this.NbPlus65MesureTransitoireAcharge = 0;
        this.More65TransitionalMeasureDependant=0;

        //this.NbPlus65MesureTransitoireHandicapesAcharge = 0;
        this.More65TransitionalMeasureDisabledDependant=0;

        //this.NbAutresAcharge = 0;
        this.OthersDependant=0;
        //this.NbAutresHandicapesAcharge = 0;
        this.OthersDisabledDependant=0;

        //this.NbPlus65SituationDependanceAcharge = 0;
        this.More65DependanceSituationDependant=0;

        //this.NbPlus65SituationDependanceHandicapesAcharge = 0;
        this.More65DependanceSituationDisabledDependant=0;

        //screen 1 advanced
        this.UserName = "";

        //screen 2
        this.NetToBrut = false;
        this.ContractType = 0;

        //screen 2 advanced
        this.OnssSubmitted=false;
        this.SecondaryActivity = false;
        this.JointCommittee="";
        this.NumberEmployees="";
        this.OnssPrefix="";
        this.ProfDeductionSubmitted="";
        this.PartTime=false;

        this.MondaySchedule= "0";
        this.TuesdaySchedule= "0";
        this.WednesdaySchedule= "0";
        this.ThursdaySchedule= "0";
        this.FridaySchedule= "0";
        this.SaturdaySchedule= "0";
        this.SundaySchedule= "0";
            
        this.MondayScheduleRef= "0";
        this.TuesdayScheduleRef= "0";
        this.WednesdayScheduleRef= "0";
        this.ThursdayScheduleRef= "0";
        this.FridayScheduleRef= "0";
        this.SaturdayScheduleRef= "0";
        this.SundayScheduleRef= "0";
    

        //screen 3 - advanced only
        this.MonthlyAmount = 0;
        this.ProfDeductionAmount = 0;
        this.GrossSubmittedAmount=0;

        //screen 3 - benefits section
        this.NetBenefitAmount = 0;
        this.NetCarBenefitAmount = 0;
        this.HasWorkHomeBenefit = false;
        this.CollectiveInsuranceAmount = 0;
        this.OtherPositiveAmount = 0;
        this.OtherNegativeAmount = 0;

        //screen 3 - others section
        this.CollectiveInsuranceEmployeurIntervAmount = 0;
        this.EndYearBonusAmount = 0;
        this.EndYearBonusAmountForemSubmitted=0;
        this.EndYearBonusAmountForemNotSubmitted=0;
        this.Commissions=0;
        this.NonReccurentDirectorAmount = 0;
        this.MonthlyCopyrightAmount = 0;

        //screen 3 - bonus
        this.CurrentDoubleBonusAmount = 0;
        this.CurrentAdditionalBonusAmount = 0;
        this.PreviousBonusAmount = 0;
        this.PreviousDoubleBonusAmount = 0;
        this.PreviousAdditionalBonusAmount = 0;
        this.AdvanceBonusAmount = 0;
        this.AdvanceDoubleBonusAmount = 0;
        this.AdvanceAdditionalBonusAmount = 0;

        //screen 3 - mobility
        this.PublicTransportationAmount = 0;
        this.PrivateTransportationAmount = 0;
    }

    agent: string;

    //screen 1

    currentPage: number;
    loadFromPresta : boolean;

    Period: number;
    EstablishmentUnit: string;
    HomeRegionCode:string;
    HiringType: number;
    Spouse: number;
    Dependant: boolean;

    MaritalStatus: number;
    BirthDate: string;
    Disabled: boolean;
    DisabledSpouse: boolean;

    DependantChildren: number;
    DisabledDependantChildren: number;

    More65TransitionalMeasureDependant: number;
    More65TransitionalMeasureDisabledDependant: number;

    OthersDependant: number;
    OthersDisabledDependant: number;

    More65DependanceSituationDependant: number;
    More65DependanceSituationDisabledDependant: number;

    //screen 1 advanced
    UserName: string;
    

    //screen 2
    NetToBrut: boolean;
    ContractType:number;
   
    //screen 2 advanced
    OnssSubmitted: boolean;
    SecondaryActivity: boolean;
    JointCommittee: string;
    NumberEmployees: string;
    OnssPrefix: string;
    ProfDeductionSubmitted: string;
    PartTime: boolean;

    //HorLundi: string;
    MondaySchedule:string;
    TuesdaySchedule:string;
    WednesdaySchedule:string;
    ThursdaySchedule:string;
    FridaySchedule:string;
    SaturdaySchedule:string;
    SundaySchedule:string;
    
    MondayScheduleRef:string;
    TuesdayScheduleRef:string;
    WednesdayScheduleRef:string;
    ThursdayScheduleRef:string;
    FridayScheduleRef:string;
    SaturdayScheduleRef:string;
    SundayScheduleRef:string;

    //screen 3 - advanced only
    MonthlyAmount: number; //should be the same element as screen 2 too
    ProfDeductionAmount: number;
    GrossSubmittedAmount:number;

    
    //screen 3 - benefits section
    NetBenefitAmount: number;
    NetCarBenefitAmount: number;
    HasWorkHomeBenefit: boolean;
    CollectiveInsuranceAmount: number;
    OtherNegativeAmount: number;
    OtherPositiveAmount: number;

    //screen 3 - others section
    CollectiveInsuranceEmployeurIntervAmount: number;
    EndYearBonusAmount: number;
    EndYearBonusAmountForemSubmitted:number;
    EndYearBonusAmountForemNotSubmitted:number;


    Commissions:number;
    
    // CollectiveInsuranceAmount: number; field duplicate in webflow model
    NonReccurentDirectorAmount: number;
    MonthlyCopyrightAmount: number;

    //screen 3 - bonus
    CurrentDoubleBonusAmount: number;
    CurrentAdditionalBonusAmount: number;
    PreviousBonusAmount: number;
    PreviousDoubleBonusAmount: number;
    PreviousAdditionalBonusAmount: number;
    AdvanceBonusAmount: number;
    AdvanceDoubleBonusAmount: number;
    AdvanceAdditionalBonusAmount: number;

    //screen 3 - mobility
    PublicTransportationAmount: number;
    PrivateTransportationAmount: number;
}